'use strict';
var __importDefault =
    (this && this.__importDefault) ||
    function(mod) {
        return mod && mod.__esModule ? mod : { default: mod };
    };
Object.defineProperty(exports, '__esModule', { value: true });
exports.generateLightColors = exports.generateDarkColors = exports.getColorsList = exports.isValidHex = void 0;
// Dependencies
const color_1 = __importDefault(require('color'));
const numberToHex = (value) => '#' + value;
const ERROR_COLOR = 'transparent';
exports.isValidHex = (color) => {
    if (!color || typeof color !== 'string') return false;
    if (color.substring(0, 1) === '#') color = color.substring(1);
    switch (color.length) {
        case 3:
            return /^[0-9A-F]{3}$/i.test(color);
        case 6:
            return /^[0-9A-F]{6}$/i.test(color);
        case 8:
            return /^[0-9A-F]{8}$/i.test(color);
        default:
            return false;
    }
};
function getColorsList({ colorsAmount, colorsShiftAmount, mixColor, rotate, saturation, mainColor }) {
    const formatColor = mainColor.replace('#', '');
    const colorsList = [];
    const givenColor = exports.isValidHex(numberToHex(formatColor)) ? numberToHex(formatColor) : ERROR_COLOR;
    let step;
    for (step = 0; step < colorsAmount; step++) {
        if (exports.isValidHex(numberToHex(formatColor))) {
            colorsList.push(
                color_1
                    .default(givenColor)
                    .rotate(((step + 1) / colorsAmount) * -rotate)
                    .saturate(((step + 1) / colorsAmount) * (saturation / 100))
                    .mix(color_1.default(mixColor), ((colorsShiftAmount / 100) * (step + 1)) / colorsAmount)
                    .hex()
            );
        } else {
            colorsList.push(ERROR_COLOR);
        }
    }
    return colorsList;
}
exports.getColorsList = getColorsList;
function generateDarkColors(mainColor) {
    const configColorsDark = {
        colorsAmount: 4,
        colorsShiftAmount: 80,
        mixColor: 'black',
        rotate: 6,
        saturation: 15,
        mainColor
    };
    const colors = getColorsList(configColorsDark);
    return Object.values(colors).reduce((prev, curr, index) => Object.assign({ [(index + 1) * 100 + 500]: curr }, prev), {});
}
exports.generateDarkColors = generateDarkColors;
function generateLightColors(mainColor) {
    const configColorsLight = {
        colorsAmount: 4,
        colorsShiftAmount: 95,
        mixColor: 'white',
        rotate: -5,
        saturation: -5,
        mainColor
    };
    const colors = getColorsList(configColorsLight);
    return Object.values(colors)
        .reverse()
        .reduce((prev, curr, index) => Object.assign({ [(index + 1) * 100]: curr }, prev), {});
}
exports.generateLightColors = generateLightColors;
function generateFamilyColors(mainColor) {
    return Object.assign(Object.assign(Object.assign({}, generateLightColors(mainColor)), { 500: mainColor }), generateDarkColors(mainColor));
}
exports.default = generateFamilyColors;
